// Renders the comparison chip strip used by the organisation-group dashboards
// (response_times, sleep_data, support_entries). The outer `summary` container
// (with its static "Comparing:" intro and "Clear all" button) is shown/hidden
// via `.d-none`; the `list` element is rebuilt with one chip per selected
// comparator. The strip stays hidden when no comparators are selected.
//
// Built to comfortably handle up to ~10 simultaneous selections — chips wrap to
// multiple rows and long names truncate with ellipsis instead of overflowing.

import { t } from '../javascript/lib/i18n';

export function renderCompareChips({
  summary,
  list,
  selectedItems,
  colorPool,
  labelFor,
  removeAction,
}) {
  if (!summary || !list) return;

  if (selectedItems.size === 0) {
    summary.classList.add('invisible');
    list.replaceChildren();
    return;
  }

  summary.classList.remove('invisible');

  const chips = [];
  for (const compareId of selectedItems) {
    chips.push(buildChip({ compareId, colorPool, labelFor, removeAction }));
  }
  list.replaceChildren(...chips);
}

function buildChip({ compareId, colorPool, labelFor, removeAction }) {
  const chip = document.createElement('button');
  chip.type = 'button';
  chip.className = 'amba-pill btn';
  chip.dataset.compareId = compareId;
  chip.setAttribute('data-action', `click->${removeAction}`);

  const labelText = labelFor(compareId);
  chip.setAttribute(
    'aria-label',
    t('js.compare_chip_strip.remove_from_comparison', { label: labelText })
  );

  const swatch = document.createElement('span');
  swatch.className = 'amba-pill__swatch';
  swatch.setAttribute('aria-hidden', 'true');
  const color = colorPool.get(compareId);
  if (color) swatch.style.backgroundColor = color;

  const label = document.createElement('span');
  label.textContent = labelText;

  const remove = document.createElement('span');
  remove.className = 'amba-pill__remove';
  remove.setAttribute('aria-hidden', 'true');
  remove.textContent = '×';

  chip.append(swatch, label, remove);
  return chip;
}
